<template>
  <v-navigation-drawer
    close-on-click
    v-if="['xs', 'sm'].includes($size)"
    right
    :value="value"
    @input="$emit('input', $event)"
    app
    width="100%"
    class="nav-drawer"
    hide-overlay
    :class="{ collapsed }"
  >
    <v-list dense class="terminus-sidebar">
      <v-list-item link to="/gta">
        <v-list-item-content>
          <v-list-item-title class="text-wrap">GTA Nominees</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/jury">
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >Jury Award Winners</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/socials">
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            ><span>#CMFTERMINUS</span> <span>2021</span></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/birthday">
        <v-list-item-content>
          <v-list-item-title class="text-wrap"
            >Happy
            <span style="white-space: nowrap"
              >Birthday CMF</span
            ></v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item link href="https://campusmoviefest.com/terminus/about">
        <v-list-item-content>
          <v-list-item-title class="text-wrap">About</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "TerminusSidebar",
  props: {
    value: Boolean,
    collapsed: Boolean
  }
};
</script>

<style scoped lang="scss">
.terminus-sidebar {
  ::v-deep .v-list-item__title {
    font-size: 16px;
    line-height: 1.6em;
  }

  .v-list-item__content {
    padding: 1em 0;
  }

  .v-list-item__title {
    font-family: $body-font-family, sans-serif;
    font-weight: 300;
    font-size: 42px;
    line-height: 0.95;
    text-transform: uppercase;
    color: $cmf-darkgrey;
  }
}

.theme--light.v-navigation-drawer.nav-drawer {
  background: linear-gradient(180deg, #ef8d56 0%, #f9efe7 100%);
  top: 154px !important;
  &.collapsed {
    top: 84px !important;
  }
}

@media screen and (max-width: 375px) {
  .terminus-sidebar {
    .v-list-item__title {
      font-size: 9.6vw;
    }
  }
}
</style>
